import { render, staticRenderFns } from "./filemanagement.vue?vue&type=template&id=259550ef&scoped=true"
import script from "./filemanagement.vue?vue&type=script&lang=js"
export * from "./filemanagement.vue?vue&type=script&lang=js"
import style0 from "./filemanagement.vue?vue&type=style&index=0&id=259550ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259550ef",
  null
  
)

export default component.exports